






















import Vue from 'vue';

export default Vue.extend({
    props: ['deck', 'deckId', 'dueCards'],
    computed: {
        isActiveItem() {
            return this.deckId == this.$route.params.id;
        }
    },
});
